import React from 'react';
import BrandMark from './BrandMark';
import { getInfoEmail } from '../utils/branding';

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const FOOTER_LINKS = [
  { id: 'services', label: 'Services' },
  { id: 'cloud', label: 'Cloud Expertise' },
  { id: 'expertise', label: 'Company Expertise' },
];

const Footer = () => {
  const infoEmail = getInfoEmail();
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-brand">
            <BrandMark color="#8AA0B3" />
            <div>
              <div className="fb-name">JbnWorks</div>
              <div className="fb-tag">Connecting You to the World Through Innovative Software Solutions</div>
            </div>
          </div>
          <div className="footer-links">
            {FOOTER_LINKS.map(({ id, label }) => (
              <button key={id} onClick={() => scrollTo(id)}>{label}</button>
            ))}
            <a href={`mailto:${infoEmail}`}>{infoEmail}</a>
          </div>
        </div>
        <div className="footer-bottom">
          &copy; {year} JbnWorks. This catalog is prepared for prospective client review and is not a
          binding commercial offer.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
